var _excluded = ["autoComplete", "value", "placeholder", "type", "size", "prefix", "suffix", "tooltip", "icon", "name", "list", "errorMessage", "ctaLink", "ctaIcon", "isIconVisibleWhenHasValue", "isLoading", "hasError", "hasHiddenBorder", "hasSuccess", "hasAutofocus", "shadow", "isPlaceholderVisibleWhenHasValue", "onChange", "uploadedFilesNames", "onKeyPress", "readOnly", "backgroundColor", "className", "onClick", "hasHiddenNumberControls", "hasCenteredValue"];
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useContext, useEffect, useRef, useState, forwardRef } from "react";
import OnColorContext from "../../../contexts/OnColorContext";
import ResizeDetector from "../../../helpers/ResizeDetector";
import useBreakpoint from "../../../hooks/useBreakpoint";
import IconAtm from "../../atoms/IconAtm";
import IconButtonAtm from "../../atoms/IconButtonAtm";
import BreakpointVisibilityOrg from "../../organisms/BreakpointVisibilityOrg";
import CtaIcon from "./Components/CtaIcon";
import CtaLink from "./Components/CtaLink";
import ErrorMessage from "./Components/ErrorMessage";
import FileUploadInput from "./Components/FileUploadInput";
import List from "./Components/List";
import Placeholder from "./Components/Placeholder";
import Tooltip from "./Components/Tooltip";
import { EyeSlash, Eye, Upload } from "./icons";
import { defaultProps, InputTypes } from "./InputMol.props";
import { Loader, PlaceholderWrapper, CtaWrapper, Prefix, SuffixWrapper, SuffixInputTextPlaceholder, Suffix, InputWrapper, StyledIcon, StyledInputMol, iconVisibilityBreakpoint } from "./InputMol.styled";

/**
 * 1. Prevents hiding of datalist when there's no provided value
 * */
var InputMol = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var autoComplete = _ref.autoComplete,
    value = _ref.value,
    placeholder = _ref.placeholder,
    _ref$type = _ref.type,
    type = _ref$type === void 0 ? defaultProps.type : _ref$type,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? defaultProps.size : _ref$size,
    prefix = _ref.prefix,
    suffix = _ref.suffix,
    tooltip = _ref.tooltip,
    icon = _ref.icon,
    name = _ref.name,
    list = _ref.list,
    errorMessage = _ref.errorMessage,
    ctaLink = _ref.ctaLink,
    ctaIcon = _ref.ctaIcon,
    isIconVisibleWhenHasValue = _ref.isIconVisibleWhenHasValue,
    isLoading = _ref.isLoading,
    hasError = _ref.hasError,
    hasHiddenBorder = _ref.hasHiddenBorder,
    hasSuccess = _ref.hasSuccess,
    hasAutofocus = _ref.hasAutofocus,
    shadow = _ref.shadow,
    _ref$isPlaceholderVis = _ref.isPlaceholderVisibleWhenHasValue,
    isPlaceholderVisibleWhenHasValue = _ref$isPlaceholderVis === void 0 ? defaultProps.isPlaceholderVisibleWhenHasValue : _ref$isPlaceholderVis,
    onChange = _ref.onChange,
    uploadedFilesNames = _ref.uploadedFilesNames,
    onKeyPress = _ref.onKeyPress,
    readOnly = _ref.readOnly,
    _ref$backgroundColor = _ref.backgroundColor,
    backgroundColor = _ref$backgroundColor === void 0 ? defaultProps.backgroundColor : _ref$backgroundColor,
    className = _ref.className,
    onClick = _ref.onClick,
    hasHiddenNumberControls = _ref.hasHiddenNumberControls,
    hasCenteredValue = _ref.hasCenteredValue,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var onColor = useContext(OnColorContext);
  var isMediumUp = useBreakpoint(iconVisibilityBreakpoint);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    suffixWidth = _useState2[0],
    setSuffixWidth = _useState2[1];
  var prefixWidthProviderRef = useRef(null);
  var ctaWrapperWidthProviderRef = useRef(null);
  var inputRef = useRef(null);
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    focus = _useState4[0],
    setFocus = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    hover = _useState6[0],
    setHover = _useState6[1];
  var _useState7 = useState(undefined),
    _useState8 = _slicedToArray(_useState7, 2),
    prefixWidth = _useState8[0],
    setPrefixWidth = _useState8[1];
  var _useState9 = useState(undefined),
    _useState10 = _slicedToArray(_useState9, 2),
    ctaWrapperWidth = _useState10[0],
    setCtaWrapper = _useState10[1];
  var _useState11 = useState(false),
    _useState12 = _slicedToArray(_useState11, 2),
    passwordVisibility = _useState12[0],
    setPasswordVisibility = _useState12[1];
  var _useState13 = useState(false),
    _useState14 = _slicedToArray(_useState13, 2),
    passwordIconVisibility = _useState14[0],
    setPasswordIconVisibility = _useState14[1];
  var _useState15 = useState(type),
    _useState16 = _slicedToArray(_useState15, 2),
    inputType = _useState16[0],
    setInputType = _useState16[1];
  var _useState17 = useState(!!icon),
    _useState18 = _slicedToArray(_useState17, 2),
    isIconVisible = _useState18[0],
    setIsIconVisible = _useState18[1];
  var isTextInputType = inputType === InputTypes.TEXT;
  var isPasswordInputType = inputType === InputTypes.PASSWORD;
  var isFileUploadInputType = inputType === InputTypes.FILE;
  var wasPasswordInputTypeOnInit = type === InputTypes.PASSWORD;
  var hasIcon = !!icon;
  var hasValue = !!value;
  var hasUploadValue = !!uploadedFilesNames;
  var hasTooltip = !!tooltip;
  var hasCtaLink = !!ctaLink;
  var hasCtaIcon = !!ctaIcon;
  var hasPrefix = !!prefix;
  var hasSuffix = !!suffix;
  var isPlaceholderVisible = isIconVisibleWhenHasValue ? false : isPlaceholderVisibleWhenHasValue;
  var setCtaWrapperWidthValue = useCallback(function () {
    var _ctaWrapperWidthProvi;
    setCtaWrapper((_ctaWrapperWidthProvi = ctaWrapperWidthProviderRef.current) === null || _ctaWrapperWidthProvi === void 0 ? void 0 : _ctaWrapperWidthProvi.clientWidth);
  }, []);
  var handleWindowResize = useCallback(function () {
    setCtaWrapperWidthValue();
  }, [setCtaWrapperWidthValue]);
  var handleIconVisibility = useCallback(function () {
    if (!isIconVisibleWhenHasValue && hasValue || !isMediumUp) {
      setIsIconVisible(false);
    } else if (!isIconVisibleWhenHasValue && !hasValue || isIconVisibleWhenHasValue) {
      setIsIconVisible(true);
    } else if (!isIconVisibleWhenHasValue && !hasUploadValue || hasUploadValue) {
      setIsIconVisible(true);
    }
  }, [hasValue, isIconVisibleWhenHasValue, isMediumUp, hasUploadValue]);
  useEffect(function () {
    if (hasIcon) {
      handleIconVisibility();
    }
  }, [handleIconVisibility, hasIcon]);
  useEffect(function () {
    var _prefixWidthProviderR;
    setPrefixWidth((_prefixWidthProviderR = prefixWidthProviderRef.current) === null || _prefixWidthProviderR === void 0 ? void 0 : _prefixWidthProviderR.clientWidth);
    setCtaWrapperWidthValue();
    window.addEventListener("resize", handleWindowResize);
    if (passwordIconVisibility) {
      setCtaWrapperWidthValue();
    }
    if (isPasswordInputType) {
      setPasswordIconVisibility(true);
    } else {
      setPasswordIconVisibility(false);
    }
  }, [prefix, suffix, handleWindowResize, passwordIconVisibility, inputType, setCtaWrapperWidthValue, isPasswordInputType]);
  useEffect(function () {
    if (hasAutofocus) {
      var _inputRef$current;
      (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 || _inputRef$current.focus();
    }
  }, [hasAutofocus]);
  var handleOnFocus = function handleOnFocus() {
    setFocus(true);
  };
  var handleOnBlur = function handleOnBlur() {
    setFocus(false);
    setHover(false);
  };
  var handleOnMouseEnter = function handleOnMouseEnter() {
    setHover(true);
  };
  var handleOnMouseLeave = function handleOnMouseLeave() {
    /* 1 */
    if (!focus) {
      setHover(false);
    }
  };
  var handlePasswordVisibility = function handlePasswordVisibility() {
    setPasswordVisibility(function (visibilityValue) {
      return !visibilityValue;
    });
    if (isPasswordInputType) {
      setInputType(InputTypes.TEXT);
    } else if (isTextInputType) {
      setInputType(InputTypes.PASSWORD);
    }
  };
  var handleOnCtaLinkClick = function handleOnCtaLinkClick(event) {
    event.preventDefault();
    if (!isFileUploadInputType) {
      setInputType(InputTypes.TEXT);
      setPasswordVisibility(true);
    }
    if (ctaLink) {
      ctaLink.onClick(event);
    }
  };
  var ctaLinkJsx = ctaLink && /*#__PURE__*/React.createElement(CtaLink, {
    text: ctaLink.text,
    isFileUpload: isFileUploadInputType,
    onClick: handleOnCtaLinkClick
  });
  var ctaIconJsx = ctaIcon && /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundColor
  }, /*#__PURE__*/React.createElement(CtaIcon, {
    icon: ctaIcon.icon,
    onClick: ctaIcon.onClick
  }));
  var inputJsx = /*#__PURE__*/React.createElement(StyledInputMol, {
    autoComplete: autoComplete,
    list: list ? list.id : undefined,
    value: value,
    placeholder: placeholder,
    name: name,
    className: className,
    type: inputType,
    multiple: isFileUploadInputType,
    onChange: onChange,
    onFocus: handleOnFocus,
    onBlur: handleOnBlur,
    onMouseEnter: handleOnMouseEnter,
    onMouseLeave: handleOnMouseLeave,
    onKeyPress: onKeyPress,
    readOnly: readOnly,
    onClick: onClick,
    $onColor: onColor,
    $hasPlaceholder: !!placeholder,
    $isPlaceholderVisibleWhenHasValue: isPlaceholderVisible,
    $hasValue: hasValue,
    $hasPrefix: hasPrefix,
    $hasSuffix: hasSuffix,
    $hasFocus: focus,
    $hasHover: hover,
    $hasHiddenBorder: hasHiddenBorder,
    $isPassword: isPasswordInputType,
    $hasCtaLink: hasCtaLink,
    $hasCtaIcon: hasCtaIcon,
    $isLoading: isLoading,
    $hasError: hasError,
    $hasSuccess: hasSuccess,
    $shadow: shadow,
    $prefixWidth: prefixWidth,
    $suffixWidth: suffixWidth,
    $ctaWrapperWidth: ctaWrapperWidth,
    $hasTooltip: hasTooltip,
    $hasIcon: isIconVisible,
    ref: ref || inputRef,
    $size: size,
    $isFileUpload: isFileUploadInputType,
    $readOnly: readOnly,
    $backgroundColor: backgroundColor,
    $hasHiddenNumberControls: type === "number" && hasHiddenNumberControls,
    $hasCenteredValue: hasCenteredValue
  });
  return /*#__PURE__*/React.createElement("div", restProps, /*#__PURE__*/React.createElement(InputWrapper, null, placeholder && !(hasCtaLink && isLoading) && !(isFileUploadInputType && isLoading) && isPlaceholderVisible ? /*#__PURE__*/React.createElement(PlaceholderWrapper, {
    $hasValue: hasValue,
    $size: size
  }, /*#__PURE__*/React.createElement(Placeholder, {
    placeholder: placeholder,
    hasValue: hasValue,
    hasError: hasError,
    hasSuccess: hasSuccess
  })) : null, prefix ? /*#__PURE__*/React.createElement(Prefix, {
    $hasPlaceholder: !!placeholder,
    $isPlaceholderVisibleWhenHasValue: isPlaceholderVisibleWhenHasValue,
    $width: prefixWidth,
    $hasValue: hasValue,
    ref: prefixWidthProviderRef
  }, prefix) : null, isIconVisible ? /*#__PURE__*/React.createElement(OnColorContext.Provider, {
    value: backgroundColor
  }, /*#__PURE__*/React.createElement(StyledIcon, {
    icon: icon,
    sizeSpace: 2
  })) : null, isLoading ? /*#__PURE__*/React.createElement(Loader, {
    $hasCtaLink: hasCtaLink,
    $hasTooltip: hasTooltip,
    $hasFileUpload: isFileUploadInputType
  }) : null, isFileUploadInputType ? /*#__PURE__*/React.createElement(FileUploadInput, {
    size: size,
    focus: focus,
    onColor: onColor,
    hasError: hasError,
    hasSuccess: hasSuccess,
    placeholder: placeholder,
    ctaWrapperWidth: ctaWrapperWidth,
    uploadedFilesNames: uploadedFilesNames
  }, inputJsx) : /*#__PURE__*/React.createElement(React.Fragment, null, " ", inputJsx, " "), suffix ? /*#__PURE__*/React.createElement(SuffixWrapper, {
    $hasPlaceholder: !!placeholder,
    $isPlaceholderVisibleWhenHasValue: isPlaceholderVisibleWhenHasValue,
    $hasValue: hasValue
  }, /*#__PURE__*/React.createElement(SuffixInputTextPlaceholder, {
    $suffixWidth: suffixWidth,
    $isLoading: isLoading
  }, value), /*#__PURE__*/React.createElement(ResizeDetector, {
    setWidth: setSuffixWidth,
    hasSpanWrapper: true
  }, /*#__PURE__*/React.createElement(Suffix, null, suffix))) : null, tooltip ? /*#__PURE__*/React.createElement(Tooltip, {
    content: tooltip
  }) : null, hasCtaLink || hasCtaIcon || wasPasswordInputTypeOnInit ? /*#__PURE__*/React.createElement(CtaWrapper, {
    ref: ctaWrapperWidthProviderRef
  }, hasValue && wasPasswordInputTypeOnInit ? /*#__PURE__*/React.createElement(IconButtonAtm, {
    key: "".concat(passwordVisibility),
    icon: passwordVisibility ? EyeSlash : Eye,
    sizeSpace: 2,
    onClick: handlePasswordVisibility
  }) : null, !isFileUploadInputType && !hasCtaIcon && /*#__PURE__*/React.createElement(BreakpointVisibilityOrg, {
    from: "medium"
  }, ctaLinkJsx), isFileUploadInputType ? /*#__PURE__*/React.createElement(React.Fragment, null, !hasUploadValue ? /*#__PURE__*/React.createElement(IconAtm, {
    icon: Upload,
    sizeSpace: 2
  }) : /*#__PURE__*/React.createElement(React.Fragment, null, ctaLinkJsx)) : null, ctaIconJsx) : null), hasError ? /*#__PURE__*/React.createElement(ErrorMessage, {
    message: errorMessage
  }) : null, list ? /*#__PURE__*/React.createElement(List, {
    list: list
  }) : null);
});
export default InputMol;